<template>
  <div class="discountsHourly container">
    <div class="slots">
      <div
        class="slot"
        v-for="(slot, index) in data"
        v-bind:key="index">
        <div class="titleWrapper">
          <div class="title">
            <span class="colored">{{ slot.startHour | onlyHour }} - {{ slot.endHour | onlyHour}}</span>
            saatleri arası
            <br class="d-none d-xs-block">
            süper indirimler
          </div>
          <div class="description">
            <span class="time"> {{ slot.startHour | toNow(isPreview ? expectedNow : serverTime) }} sonra</span> başlayacak
          </div>
        </div>
        <div class="productsWrapper">
          <div
            :class="['productList', 'productSize', getBoxSize(slot.numberOfGridColumns)]">
            <div
              v-for="(campaign, index) in slot.campains"
              v-bind:key="index"
              :class="['product', getColumnSize(slot.numberOfGridColumns), 'col-xs-12']"
              v-on:click="handleOnClick(campaign, slot, index)"
              v-bind:data-hbus="handleViewEventData(campaign, slot, index)"
            >
              <discountsHourlyProductSummaryBox
                :data="campaign"
                :box-size="getBoxSize(slot.numberOfGridColumns)"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import discountsHourlyProductSummaryBox from "../../view/productSummaryBoxes/discountsHourlyProductSummaryBox/discountsHourlyProductSummaryBox";
import { onlyHour, toNow } from "../../utils/date";
import { BOX_SIZES } from "../../view/productSummaryBoxes/discountsHourlyProductSummaryBox/discountsHourlyProductSummaryBoxConstants";
import moment from 'moment';
import { SLOT_NAMES } from '../../analytics/davinci/constants';

export default {
  name: "DiscountsHourly",
  data() {
    return {
      BOX_SIZES,
      isPreview: this.$parent.isPreview,
      expectedNow: moment(this.$parent.expectedNow).format(),
      slotName: SLOT_NAMES.FUTURE_CAMPAIGN_SLOTS
    };
  },
  props: {
    data: Array,
    serverTime: String,
    onClick: Function,
    viewEventData: Function
  },
  filters: {
    onlyHour, toNow
  },
  methods: {
    getBoxSize: function(length){
      return length >= 4 ? BOX_SIZES.SMALL : length >= 3 ? BOX_SIZES.MEDIUM : BOX_SIZES.LARGE;
    },
    getColumnSize: function (length) {
      return length >= 4 ? 'col-3' : length >= 3 ? 'col-4' : 'col-6'
    },
    handleOnClick: function (item, slot, index) {
      this.onClick(item, slot, this.slotName, index);
    },
    handleViewEventData: function (item, slot, index) {
      return this.viewEventData(item, slot, this.slotName, index)
    },
  },
  created () {},
  components: {
    discountsHourlyProductSummaryBox,
  }
};
</script>

<style src="./DiscountsHourly.scss" lang="scss" scoped/>



// WEBPACK FOOTER //
// src/partials/DiscountsHourly/DiscountsHourly.vue